// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.virtual-portal .my-profile-photo a.button-link {
  color: white; }

.virtual-portal .my-profile-photo button.btn-danger, .virtual-portal .my-profile-photo .custom-file-upload.btn-danger {
  background-color: #fa504b;
  color: white;
  border: none; }
  .virtual-portal .my-profile-photo button.btn-danger:hover, .virtual-portal .my-profile-photo .custom-file-upload.btn-danger:hover {
    border-color: #fb736f;
    background-color: #fb736f;
    color: #ffffff; }

.virtual-portal .my-profile-photo p {
  color: #6D6E71; }
`, "",{"version":3,"sources":["webpack://./src/components/VirtualPortal/Profile/profile.css"],"names":[],"mappings":"AAAA;EACE,YAAY,EAAE;;AAEhB;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY,EAAE;EACd;IACE,qBAAqB;IACrB,yBAAyB;IACzB,cAAc,EAAE;;AAEpB;EACE,cAAc,EAAE","sourcesContent":[".virtual-portal .my-profile-photo a.button-link {\n  color: white; }\n\n.virtual-portal .my-profile-photo button.btn-danger, .virtual-portal .my-profile-photo .custom-file-upload.btn-danger {\n  background-color: #fa504b;\n  color: white;\n  border: none; }\n  .virtual-portal .my-profile-photo button.btn-danger:hover, .virtual-portal .my-profile-photo .custom-file-upload.btn-danger:hover {\n    border-color: #fb736f;\n    background-color: #fb736f;\n    color: #ffffff; }\n\n.virtual-portal .my-profile-photo p {\n  color: #6D6E71; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
